/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Intervention_EndInputs */

const en_ticket_action_intervention_end = /** @type {(inputs: Ticket_Action_Intervention_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervention End`)
};

const ja_ticket_action_intervention_end = /** @type {(inputs: Ticket_Action_Intervention_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業終了`)
};

const fr_ticket_action_intervention_end = /** @type {(inputs: Ticket_Action_Intervention_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer l'intervention`)
};

const de_ticket_action_intervention_end = /** @type {(inputs: Ticket_Action_Intervention_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einsatz beenden`)
};

/**
* | output |
* | --- |
* | "Intervention End" |
*
* @param {Ticket_Action_Intervention_EndInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_intervention_end = /** @type {((inputs?: Ticket_Action_Intervention_EndInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Intervention_EndInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_intervention_end(inputs)
	if (locale === "ja") return ja_ticket_action_intervention_end(inputs)
	if (locale === "fr") return fr_ticket_action_intervention_end(inputs)
	return de_ticket_action_intervention_end(inputs)
});